import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const procesos = [
  {
    titulo: "06 Entrega de Servicios a Cliente",
    descripcion:
      "Cerrar formalmente el proceso " +
      "de implementación, capacitación, asegurando la " +
      "satisfacción del cliente y su adopción del servicio. " +
      "Formalizando la entrega y habilitar el soporte postventa.",
    acciones: [
      { label: "Procedimiento", to: "/proceso-comercial-ingenieria/entrega-servicio-cliente" },
      { label: "Matriz RACI", to: "/proceso-comercial-ingenieria/entrega-servicio-cliente-raci" },
    ],
  },
  {
    titulo: "07 Soporte a Cliente Total",
    descripcion:
      "Acompañar al cliente en la correcta adopción y " +
      "uso de la solución implementada, asegurando su operación continua " +
      "y eficiente, atendiendo las posibles incidencias o fallas que se " +
      "presenten durante el tiempo de soporte al cliente.",
    acciones: [
      { label: "Procedimiento", to: "/proceso-comercial-ingenieria/soporte-cliente-total" },
    ],
  },
];

const ProcesoComercialIngenieria = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Procesos y Actividades Ingeniería</h1>
        </div>
        <div className="orgproc-grid-3col">
          {procesos.map((proceso, index) => (
            <div className="orgproc-card" key={proceso.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Proceso #{index + 1}</div>
                <div className="orgproc-card-title">{proceso.titulo}</div>
                <p className="orgproc-card-desc">{proceso.descripcion}</p>
                <div className="orgproc-card-actions">
                  {proceso.acciones.map((accion) => (
                    <Link className="orgproc-card-btn" to={accion.to} key={accion.to}>
                      {accion.label} →
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default ProcesoComercialIngenieria;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
